import { Box, Container, Typography, Link as MuiLink, Stack, IconButton } from '@mui/material';
import { Link } from 'react-router-dom';
import { Icon } from '@iconify/react';

const footerLinks = [
  { label: 'Privacy', href: '/privacy', external: false },
  { label: 'Terms', href: '/terms', external: false },
  { label: 'FAQ', href: '/faq', external: false },
];


export const Footer = () => {
  return (
    <Box
      component="footer"
      sx={{
        py: { xs: 4, md: 5 },
        mt: { xs: 10, md: 14 },
        backgroundColor: 'background.paper',
        borderTop: '1px solid',
        borderColor: 'grey.200',
      }}
    >
      <Container maxWidth="lg">
        <Box
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', md: 'row' },
            alignItems: { xs: 'flex-start', md: 'center' },
            justifyContent: 'space-between',
            gap: { xs: 4, md: 3 },
          }}
        >
          {/* Logo and Brand */}
          <Box
            component={Link}
            to="/"
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 1.5,
              textDecoration: 'none',
            }}
          >
            <Box
              component="img"
              src="/logo.svg"
              alt="Calorium"
              sx={{
                width: 36,
                height: 36,
                borderRadius: '8px',
              }}
            />
            <Typography
              sx={{
                fontWeight: 700,
                fontSize: '1.125rem',
                color: 'text.primary',
              }}
            >
              Calorium
            </Typography>
          </Box>

          {/* Navigation Links */}
          <Stack
            direction="row"
            spacing={{ xs: 2, sm: 3 }}
            sx={{
              flexWrap: 'wrap',
              gap: { xs: 1.5, sm: 0 },
            }}
          >
            {footerLinks.map((link) => (
              <MuiLink
                key={link.label}
                component={link.external ? 'a' : Link}
                to={link.external ? undefined : link.href}
                href={link.external ? link.href : undefined}
                target={link.external ? '_blank' : undefined}
                rel={link.external ? 'noopener noreferrer' : undefined}
                sx={{
                  color: 'text.secondary',
                  textDecoration: 'none',
                  fontSize: '0.875rem',
                  fontWeight: 500,
                  transition: 'color 0.2s',
                  '&:hover': {
                    color: 'primary.main',
                  },
                }}
              >
                {link.label}
              </MuiLink>
            ))}
          </Stack>

          {/* Social Links */}
          <Stack direction="row" spacing={1}>
            <IconButton
              component="a"
              href="https://www.instagram.com/caloriumapp/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram"
              sx={{
                color: 'text.secondary',
                transition: 'color 0.2s',
                '&:hover': {
                  color: 'primary.main',
                  backgroundColor: 'transparent',
                },
              }}
            >
              <Icon icon="ri:instagram-fill" width={24} />
            </IconButton>
            <IconButton
              component="a"
              href="https://www.linkedin.com/in/khakimzade/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="LinkedIn"
              sx={{
                color: 'text.secondary',
                transition: 'color 0.2s',
                '&:hover': {
                  color: 'primary.main',
                  backgroundColor: 'transparent',
                },
              }}
            >
              <Icon icon="ri:linkedin-fill" width={24} />
            </IconButton>
          </Stack>
        </Box>

        {/* Bottom line */}
        <Box
          sx={{
            mt: { xs: 4, md: 3 },
            pt: 3,
            borderTop: '1px solid',
            borderColor: 'grey.100',
            display: 'flex',
            flexDirection: { xs: 'column', sm: 'row' },
            justifyContent: 'space-between',
            alignItems: { xs: 'flex-start', sm: 'center' },
            gap: 1.5,
          }}
        >
          <Typography
            variant="body2"
            sx={{
              color: 'text.secondary',
              fontSize: '0.8125rem',
            }}
          >
            © {new Date().getFullYear()} Calorium. All rights reserved.
          </Typography>
          <MuiLink
            href="mailto:caloriumapp@gmail.com"
            sx={{
              color: 'text.secondary',
              textDecoration: 'none',
              fontSize: '0.8125rem',
              transition: 'color 0.2s',
              '&:hover': {
                color: 'primary.main',
              },
            }}
          >
            caloriumapp@gmail.com
          </MuiLink>
        </Box>
      </Container>
    </Box>
  );
};
